"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var carousel_component_1 = require("./carousel.component");
Object.defineProperty(exports, "Carousel", { enumerable: true, get: function () { return carousel_component_1.Carousel; } });
//# sourceMappingURL=index.js.map